import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/colors_and_type.css';
import './styles/app.css';

createRoot(document.getElementById('root')).render(<App />);
